var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 21.083,
    height: 21.083,
    viewBox: "0 0 21.083 21.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_64",
    d: "M1 11.542a10.542 10.542 0 1 1 10.542 10.541A10.542 10.542 0 0 1 1 11.542zm10.542-8.625a8.625 8.625 0 1 0 8.625 8.625 8.625 8.625 0 0 0-8.625-8.625z",
    "data-name": "Trazado 64",
    transform: "translate(-1 -1)",
    style: {
      fillRule: "evenodd",
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_65",
    d: "M11.958 17.5a.9.9 0 0 1-.958-.824V6.824A.9.9 0 0 1 11.958 6a.9.9 0 0 1 .958.824v9.852a.9.9 0 0 1-.958.824z",
    className: "prefix__cls-2",
    style: {
      fill: "#bfbfbf"
    },
    "data-name": "Trazado 65",
    transform: "translate(-1.417 -1.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_66",
    d: "M6 11.958A.9.9 0 0 1 6.824 11h9.852a.9.9 0 0 1 .824.958.9.9 0 0 1-.824.958H6.824A.9.9 0 0 1 6 11.958z",
    className: "prefix__cls-2",
    style: {
      fill: "#bfbfbf"
    },
    "data-name": "Trazado 66",
    transform: "translate(-1.208 -1.417)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDropdown);
export default __webpack_public_path__ + "static/media/openDropdown.dab26f06.svg";
export { ForwardRef as ReactComponent };